// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__AanSM","flex-container":"not-found_flex-container__M1bnF"};